import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-gris" data-id="element-27" data-mp="gxq6fntr12oh">
      <div className="mx-auto max-w-3xl px-3 py-5 sm:px-4 sm:py-8" data-id="element-28" data-mp="vtxn4e5y7lz0">
        <SectionHeader id="bonos" title="5 Bonos incluidos" description="Y además recibes 5 recursos prácticos — GRATIS con tu compra." data-id="element-29" data-mp="qu2xsf1tn4g2" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-30" data-mp="14r7zk2ui5h5i">
          {bonuses.map((b, i) => <li key={b.title} className={`flex flex-col rounded-xl border-2 border-dashed border-wifi/50 bg-white p-2.5 sm:p-3 ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-31" data-mp="zsevt250p4ij" data-mpi={i}>
              <p className="self-start rounded bg-amarillo px-1.5 py-0.5 text-[0.66rem] font-extrabold uppercase text-navy" data-id="element-32" data-mp="1nl3spa4fubvo">
                Bono {i + 1} — Gratis
              </p>
              <h3 className="mt-1 text-[0.82rem] font-extrabold text-navy sm:text-sm" data-id="element-33" data-mp="3pqtuuntyc3gf">{b.title}</h3>
              <p className="mt-0.5 text-[0.78rem] leading-snug text-negro/75 sm:text-sm" data-id="element-34" data-mp="3trdt5uq9hd45">{b.desc}</p>
              <p className="mt-auto pt-1 text-xs font-semibold text-negro/70" data-id="element-35" data-mp="2l2weasaayim">
                Valor: <span className="text-red-600 line-through" data-id="element-36" data-mp="7kfkeyuw6bms">{b.value}</span>
              </p>
            </li>)}
        </ul>
        <div className="mt-2 rounded-xl border-2 border-navy bg-white p-2.5 text-center" data-id="element-37" data-mp="ciqpkwa8rxyo">
          <p className="text-[0.82rem] font-extrabold text-navy sm:text-base" data-id="element-38" data-mp="gkc0wd74o46r">
            💰 Valor total de los 5 bonos: <span className="text-red-600 line-through" data-id="element-39" data-mp="ldexyvb45vrp">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 inline-block bg-amarillo px-1.5 text-[0.82rem] font-extrabold text-navy sm:text-sm" data-id="element-40" data-mp="qa5bbavjad9f">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}